export const formatArrayAsDelimitedString = ({ array, delimiter }) => {
  if(!Array.isArray(array)) {
    console.error("Invalid Array: ", array);
    return null;
  }
  return array?.join(delimiter)
}